namespace Gamification.Gamification {
    export namespace UtentiDelegatiConProprietaService {
        export const baseUrl = 'Gamification/UtentiDelegatiConProprieta';

        export declare function Create(request: Serenity.SaveRequest<UtentiDelegatiConProprietaRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<UtentiDelegatiConProprietaRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<UtentiDelegatiConProprietaRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<UtentiDelegatiConProprietaRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/UtentiDelegatiConProprieta/Create",
            Update = "Gamification/UtentiDelegatiConProprieta/Update",
            Delete = "Gamification/UtentiDelegatiConProprieta/Delete",
            Retrieve = "Gamification/UtentiDelegatiConProprieta/Retrieve",
            List = "Gamification/UtentiDelegatiConProprieta/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>UtentiDelegatiConProprietaService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
